angular.module('impactx.productlabel').component('ixProductLabelIcons', {
        bindings: {
            productLabels: '<'
        },
        controller: 'ProductLabelIconsCtrl',
        templateUrl: 'modules/search/templates/product-label-icons.html'
    }
);